import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import useModal from "../../hooks/useModal";
import { AlertService } from "../../services/Alert";
import { PaymentsService } from "../../services/PaymentsService";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
interface PayPalModalProps {
    show: boolean;
    is_active: boolean;
    data: any;
    onRequestClose: (reload: boolean) => void;
}

function PayPalModal({ show, is_active, data, onRequestClose }: PayPalModalProps) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const modalSubRef = useRef<HTMLDivElement>(null);

    useModal(modalSubRef, show)

    const defaultValues = {
        account_id: account.id,
        is_default_payment: false,
        client_id: '',
        secret: '',
    }

    const { register, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        // reset(defaultValues);
    }

    const submit = async (data) => {
        try {
            await PaymentsService.savePayPalSettings(data)
            await closeAndReset(true);
            AlertService.toastSuccess('Se guardo correctamente la configuración')
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
        }
    }

    useEffect(() => {
        if (data) {
            reset({
                account_id: account.id,
                is_default_payment: is_active,
                client_id: data.client_id,
                secret: data.secret,
            })
        }
    }, [data])


    return (
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">


                        <div className="modal-body">
                            <div className="mb-3">
                                <img src="https://v3.ws-voices.com.mx/assets/img/paypal-logo.png" className="img-fluid" />
                            </div>
                            <div className="mb-3">
                                <Input label={t("platform.payments.paypal.client-id")} errors={errors.client_id} {...register('client_id', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>
                            <div className="mb-3">
                                <Input label={t("platform.payments.paypal.secret")} errors={errors.secret} {...register('secret', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            <div className="form-check form-switch mb-4">
                                <input type="checkbox" className="form-check-input" id={'is_default_payment'} {...register(`is_default_payment`)} />
                                <label className="form-check-label" htmlFor={'is_default_payment'}>{t("platform.payments.paypal.default")}</label>
                            </div>



                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default PayPalModal